<template>
  <div
    v-if="modal"
    class="modal-backdrop"
  >
    <div
      class="modal fade show d-flex align-items-center"
      @click="$emit('reset', 'del')"
    >
      <div
        class="modal-dialog"
        @click.stop
      >
        <div class="modal-content">
          <div class="modal-body p-sm-5 text-center">
            <div class="px-2 py-4 px-sm-5 py-sm-0">
              <p class="font-weight-bold">
                {{ $t('user-management.delete-text', { name: user.fullname }) }}
              </p>
            </div>
            <div class="d-flex justify-content-center pb-4 pb-sm-0 pt-sm-4">
              <div
                class="col-sm-4 mx-1 mx-sm-3 btn btn-outline-info"
                @click="$emit('reset', 'del')"
              >
                {{ $t('user-management.cancel') }}
              </div>
              <div
                v-if="!isLoadingDelete"
                class="col-sm-4 mx-1 mx-sm-3 btn btn-info"
                @click="remove"
              >
                {{ $t('user-management.delete-user') }}
              </div>
              <div
                v-else
                class="col-sm-4 mx-1 mx-sm-3 btn btn-info text-center"
              >
                <div class="spinner-border spinner-border-sm">
                  <span class="sr-only">
                    Loading...
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalSuccess
      v-if="modalDel.success"
      class="in-front-of"
      :text-modal="modalDel.textModal"
      @closeModal="closeModal"
    />
    <ModalUnsuccessful
      v-if="modal.unsuccessful"
      :text-modal="modalDel.textModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import Api from '@/utils/Api'
import ModalSuccess from '@/components/modal/ModalSuccess'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'

export default {
  components: {
    ModalSuccess,
    ModalUnsuccessful
  },

  props: {
    modal: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      isLoadingDelete: false,
      modalDel: {
        textModal: '',
        success: false,
        unsuccessful: false
      }
    }
  },

  methods: {
    async remove () {
      this.isLoadingDelete = true
      const data = await Api.users.delete(this.user.id)
      if (data.status === 200) {
        this.modalDel.textModal = this.$t('user-management.delete-modal', { name: this.user.fullname })
        this.showModal('success')
      } else {
        this.modalDel.textModal = this.$i18n.locale === 'en' ? data.data.message.messageEng : data.data.message.messageIdn
        this.showModal('unsuccessful')
      }
      this.isLoadingDelete = false
    },
    showModal (modalname) {
      this.modalDel[modalname] = true
    },
    closeModal (modalname) {
      this.modalDel[modalname] = false
      this.$emit('reset', 'del')
    }
  }
}
</script>

<style scoped>
.modal-content {
  border: 0;
  border-radius: 18px;
  box-shadow: 0 15px 15px -10px rgba(0, 0, 0, 0.25);
}
.in-front-of {
  z-index: 1000000000;
}
</style>
